import type { ComponentPropsWithRef, ForwardedRef, JSX } from 'react';

import { forwardRef, memo } from '@change-corgi/core/react/core';
import { parseHtml } from '@change-corgi/core/react/html';

type Props = ComponentPropsWithRef<'div'> & {
	aspectRatio?: number | string;
	embedHtml: string;
};

function EmbeddedVideoInner(
	{ embedHtml, aspectRatio, ...rest }: Props,
	ref: ForwardedRef<HTMLDivElement>,
): JSX.Element {
	return (
		<div
			ref={ref}
			style={{ aspectRatio }}
			className="overflow-hidden [&_embed]:h-full [&_embed]:w-full [&_iframe]:h-full [&_iframe]:w-full [&_object]:h-full [&_object]:w-full [&_video]:h-full [&_video]:w-full"
			{...rest}
		>
			{parseHtml(embedHtml, {
				allowedTags: ['iframe'],
				allowedAttrs: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'],
			})}
		</div>
	);
}

export const EmbeddedVideo = memo(forwardRef(EmbeddedVideoInner));
